import { isShoppingCartPage } from "util/url/checkRouteInclude";

export function compactShippingFee(price: string, pathname: string) {
  let filteredPrice = price.replace("CA", "");
  if (isShoppingCartPage(pathname)) {
    filteredPrice = filteredPrice.replace(".00", "");
  }
  return filteredPrice;
}
